var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnlarge = function SvgEnlarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "h257jz4ura",
    d: "M0 0L32.999 0 32.999 33 0 33z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1E3F",
    d: "M14.136 25.566l-5.57.21 7.121-7.123c.36-.359.359-.946 0-1.305-.358-.359-.945-.359-1.304 0L7.26 24.47l.188-5.59c.014-.508-.385-.945-.893-.959-.51-.012-.94.38-.952.888l-.288 7.918c-.005.255.086.503.268.686.183.182.43.273.685.267l7.925-.28c.508-.014.913-.444.893-.946-.018-.516-.442-.9-.951-.888M18.864 7.433l5.57-.21-7.123 7.124c-.358.358-.358.945 0 1.304.36.359.946.359 1.305 0l7.122-7.122-.188 5.59c-.013.508.384.945.893.959.509.012.94-.38.952-.888l.287-7.918c.007-.255-.085-.503-.267-.685-.183-.183-.431-.274-.685-.268l-7.925.28c-.508.014-.913.444-.893.947.019.515.443.9.952.887",
    transform: "translate(-1657 -912) translate(1657 912)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1657 -912) translate(1657 912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9299knykzb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h257jz4ura"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1E3F",
    d: "M6.199 1.904c-2.369 0-4.296 1.927-4.296 4.296v20.6c0 2.368 1.927 4.296 4.296 4.296H26.8c2.368 0 4.295-1.928 4.295-4.296V6.2c0-2.369-1.927-4.296-4.295-4.296H6.199zM26.8 33H6.199C2.78 33 0 30.218 0 26.8V6.2C0 2.781 2.78 0 6.199 0H26.8c3.419 0 6.199 2.781 6.199 6.2v20.6c0 3.418-2.78 6.2-6.199 6.2z",
    mask: "url(#9299knykzb)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnlarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enlarge.31a3ef64.svg";
export { ForwardRef as ReactComponent };